import { clsx } from 'clsx'
import { AlertCircle, AlertTriangle, CheckCircle2, Info, X } from 'lucide-react'

export type AlertSeverity = 'critical' | 'warning' | 'info' | 'success'

interface AlertBannerProps {
  severity: AlertSeverity
  message: string
  onDismiss?: () => void
}

const config: Record<AlertSeverity, { classes: string; icon: React.ReactNode }> = {
  critical: {
    classes: 'bg-red-500/10 border-red-500/30 text-[--km-error]',
    icon: <AlertCircle size={16} />,
  },
  warning: {
    classes: 'bg-amber-500/10 border-amber-500/30 text-[--km-warning]',
    icon: <AlertTriangle size={16} />,
  },
  info: {
    classes: 'bg-indigo-500/10 border-indigo-500/30 text-[--km-primary]',
    icon: <Info size={16} />,
  },
  success: {
    classes: 'bg-emerald-500/10 border-emerald-500/30 text-[--km-success]',
    icon: <CheckCircle2 size={16} />,
  },
}

export function AlertBanner({ severity, message, onDismiss }: AlertBannerProps) {
  const { classes, icon } = config[severity]

  return (
    <div className={clsx('flex items-center gap-3 rounded-xl border px-4 py-3 text-sm', classes)}>
      <span className="shrink-0">{icon}</span>
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="shrink-0 hover:opacity-70 transition-opacity p-0.5 rounded"
          aria-label="Chiudi notifica"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
